import React, { useState, useEffect } from 'react'
import { money, handleSortState, sortData } from '@/Helper'
import TdSort from 'Elements/TdSort'

const headerEnd = {
    stock: {
        has_sort: true,
        sort_type: null,
        label: 'stock'
    },
    reject: {
        has_sort: true,
        sort_type: null,
        label: 'reject'
    },
    uom_name: {
        has_sort: true,
        sort_type: null,
        label: 'uom'
    },
    total_value: {
        has_sort: true,
        sort_type: null,
        className: 'cell-tr',
        label: 'total value'
    },
}

export default function DetailProduct({ show, indexParent, products, variants }) {

    const [rows, setRows] = useState(products)
    const [header, setHeader] = useState({
        no: {
            label: 'no.',
            has_sort: false,
        },
        code: {
            has_sort: true,
            sort_type: null,
            label: 'code'
        },
        brand: {
            has_sort: true,
            sort_type: null,
            label: 'brand'
        },
        name: {
            has_sort: true,
            className: 'td-width-as-content',
            sort_type: null,
            label: 'product name'
        },
        sales_price: {
            has_sort: true,
            sort_type: null,
            className: 'cell-tr',
            label: 'sales price'
        },
    })
    const sortColumn = (colName, variantIndex = 1000) => {
        setRows(prevState => {
            prevState = sortData({ type: header[colName].sort_type, column: colName, data: prevState })
            return [...prevState]
        })

        setHeader(prev => {
            return { ...handleSortState({ data: prev, column: colName }) }
        })
    }

    useEffect(() => {
        let variantHeader = {}
        let initRows = []

        Object.keys(variants).map((variant, variantIdx) => {
            variantHeader[`variant${variantIdx}`] = {
                has_sort: true,
                sort_type: null,
                className: 'cell-tr',
                label: ' '
            }
        })
        initRows = products.map(product => {
            variants.forEach((lv, lvIdx) => {
                let qty = 0;

                product.variants.forEach(v => {
                    qty += v?.types?.[lvIdx]?.stock ?? 0
                })

                product[`variant${lvIdx}`] = qty
            })
            return product
        })

        setHeader(prev => {
            return {
                ...prev,
                ...variantHeader,
                ...headerEnd
            }
        })
        setRows(initRows)

    }, [products, variants])

    // console.clear()
    // console.log(rows)

    return show && (
        <>
            {
                rows.map((product, productIdx) => (
                    <React.Fragment key={`child${productIdx}`}>
                        {
                            productIdx === 0 && (
                                <tr className="tr-detail detail-heading">
                                    {
                                        Object.keys(header).map((key, idx) => (
                                            <TdSort
                                                key={`th-${idx}`}
                                                label={header[key].label}
                                                rowspan={header[key].rowspan}
                                                colspan={header[key].colspan}
                                                sort={header[key].has_sort}
                                                handleClick={() => sortColumn(key)}
                                                className={`${header[key].className}  ${header[key].sort_type}`}
                                            />
                                        ))
                                    }
                                </tr>
                            )
                        }
                        <tr>
                            <td>{indexParent}.{productIdx + 1}</td>
                            <td className="cell-width-as-content">{product.code}</td>
                            <td className="cell-width-as-content">{product.brand}</td>
                            <td className="cell-width-as-content" >{product.name}</td>
                            <td className="cell-currency cell-tr">IDR {money(product.sales_price)}</td>
                            {
                                variants.map((lv, lvIdx) => (
                                    <td key={`variantchild${lvIdx}`}>{product[`variant${lvIdx}`]}</td>
                                ))
                            }
                            <td>{product.stock}</td>
                            <td>{product.reject}</td>
                            <td>{product.uom_name ?? '-'}</td>
                            <td className="cell-tr cell-currency">IDR {money(product.total_value)}</td>
                        </tr>
                    </React.Fragment>
                ))
            }
        </>
    )
}
